import ConnectedAdsViewMore from '@components/blog/components/post/ConnectedAdsViewMore'

const TEXT = {
    'car_ad': 'osobowe',
    'truck_ad': 'dostawcze',
    'motorcycle_ad': 'motocykle',
}

const URL = {
    'car_ad': '/samochody-osobowe',
    'truck_ad': '/samochody-dostawcze',
    'motorcycle_ad': '/motocykle',
}

export default function ConnectedAdsSections ({ connectedAds, title }) {
    if (typeof connectedAds !== 'object') return null
    const adTypes = Object.keys(connectedAds)
    if (adTypes.length < 1) return null

    return <>
        <h2 style={{fontSize:28}}>{ title || 'Powiązane ogłoszenia' }:</h2>
        { adTypes.map(adType =>
            <ConnectedAdsViewMore
                connectedAds={connectedAds[adType]}
                key={adType}
                text={TEXT[adType] || ''}
                url={URL[adType]} />) }
    </>
}